import Vue from 'vue'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false

async function bootstrap() {
  const [
    rippleModule,
    iconComponentModule
  ] = await Promise.all([
      import('vue-ripple-directive'),
      import('./icons')
  ])

  const Ripple = rippleModule.default
  const OhVueIcon = iconComponentModule.default

  Vue.component("v-icon", OhVueIcon)
  Vue.directive('ripple', Ripple)

  new Vue({
    router,
    render: h => h(App)
  }).$mount('#app')
}

bootstrap()

// optional: defer service worker (non-blocking)
if ('requestIdleCallback' in window) {
  requestIdleCallback(() => {
    import('./registerServiceWorker')
  })
} else {
  setTimeout(() => {
    import('./registerServiceWorker')
  }, 2000)
}
